module.exports = __webpack_public_path__ + "static/media/next-inactive.6b9310e2.svg";